import { absolutePath } from "./absolutePath";

export const landingPageSettings = {
  index: () => absolutePath("admin/landing_page_settings"),
  update: () => absolutePath("admin/landing_page_settings"),
};
